module.exports = __webpack_public_path__ + "img/nav-close.4519de04.svg";